import { unsplashImageSrcSet } from '../utils/unsplashImageSrcSet';

export type CityImageMeta = {
  /** Local asset under /public, or Unsplash photo id (part after `photo-`). */
  image: string;
  imagePosition: string;
  local?: boolean;
};

/**
 * Frontend overrides — API currently returns the same photoId for every city.
 * Prefer bundled images when available; fall back to Unsplash ids.
 */
export const CITY_IMAGE_OVERRIDES: Record<string, CityImageMeta> = {
  barcelona: {
    image: '/images/cities/barcelona.jpg',
    imagePosition: '50% 35%',
    local: true,
  },
  madrid: {
    image: '/images/cities/madrid.jpg',
    imagePosition: '50% 40%',
    local: true,
  },
  valencia: {
    image: '/images/cities/valencia.jpg',
    imagePosition: '50% 45%',
    local: true,
  },
  miami: {
    image: '/images/cities/miami.jpg',
    imagePosition: '50% 40%',
    local: true,
  },
  orlando: {
    image: '/images/cities/orlando.jpg',
    imagePosition: '50% 40%',
    local: true,
  },
  tampa: {
    image: '/images/cities/tampa.jpg',
    imagePosition: '50% 40%',
    local: true,
  },
};

/** Unsplash fallbacks if local files are missing (e.g. before deploy). */
const UNSPLASH_FALLBACK: Record<string, CityImageMeta> = {
  barcelona: {
    image: '1562883676-8c7feb83f09b',
    imagePosition: '50% 35%',
  },
  madrid: {
    image: '1655410799546-275c27f50616',
    imagePosition: '50% 40%',
  },
  valencia: {
    image: '1577990432593-6bf35f43beed',
    imagePosition: '50% 45%',
  },
  miami: {
    image: '1533106497176-45ae19e68ba2',
    imagePosition: '50% 40%',
  },
  orlando: {
    image: '1575089976121-8ed7b2a54265',
    imagePosition: '50% 40%',
  },
};

export type CityImageSources = {
  src: string;
  srcSet?: string;
  imagePosition: string;
};

export function getCityImageSources(
  cityId: string,
  apiPhotoId?: string,
  apiImagePosition?: string,
): CityImageSources {
  const key = cityId.toLowerCase();
  const override = CITY_IMAGE_OVERRIDES[key] ?? UNSPLASH_FALLBACK[key];

  if (override?.local) {
    return {
      src: override.image,
      imagePosition: override.imagePosition,
    };
  }

  if (override) {
    const { src, srcSet } = unsplashImageSrcSet(override.image);
    return { src, srcSet, imagePosition: override.imagePosition };
  }

  const photoId = apiPhotoId ?? '1562883676-8c7feb83f09b';
  const { src, srcSet } = unsplashImageSrcSet(photoId);
  return {
    src,
    srcSet,
    imagePosition: apiImagePosition ?? '50% 50%',
  };
}
